<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <!--                        <div class="modal-head">-->
          <!--                            <h1></h1>-->
          <!--                        </div>-->

          <!--          <div class="modal-delete">-->
          <!--            <i class="i-modal-delete"></i>-->
          <!--          </div>-->

          <div class="modal-con">
            <div class="modal-txt" v-html="content" />
            <!--              {{ $t('modal.not_same_store_product.content') }}-->
            <!--              {{ content }}-->
            <!--            </div>-->
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn yd-cta yd-cta--primary" @click="confirm">
                <!--                {{ $t('modal.not_same_store_product.confirmText') }}-->
                {{ confirmText }}
              </button>
              <button class="btn bo yd-cta yd-cta--secondary" @click="close">
                <!--                {{ $t('modal.not_same_store_product.rejectText') }}-->
                {{ rejectText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const { data } = defineProps(['data']);
const emit = defineEmits(['close']);
const { content, confirmText, rejectText, confirmCallBack } = data;

const close = () => emit('close');
const confirm = () => {
  emit('close');
  confirmCallBack();
};
</script>

<style scoped></style>
/* *Created on 2023-10-13 *ProjectName user */
